import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Home from '@/components/Home.vue'
import Software from '@/components/Statistics/Software/SoftwareCount.vue'
import Statistics from '@/components/Statistics/StatisticsVersion.vue'
import StatisticsInfo from '@/components/Statistics/StatisticsInfo.vue'
import BaseMetricsSum from '@/components/Statistics/BaseMetricsSum.vue'
import BaseMetricsDetail from '@/components/Statistics/BaseMetricsDetail.vue'
import BusinessMetricsSum from '@/components/Statistics/BusinessMetricsSum.vue'
import BusinessMetricsDetail from '@/components/Statistics/BusinessMetricsDetail.vue'
import ConfigurationData from '@/components/Statistics/ConfigurationData.vue'
import Maps from '@/components/Maps/Maps.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    redirect: { name: 'home' }
  },
  {
    path: '/software',
    name: 'software',
    component: Software
  },
  {
    path: '/versionStatistics',
    name: 'statistics',
    component: Statistics
  },
  {
    path: '/versionStatistics/:softwareCode/:softwareVersion',
    name: 'StatisticsInfo',
    component: StatisticsInfo
  },
  {
    path: '/statistics/baseStatisticsSum',
    name: 'baseStatisticsSum',
    component: BaseMetricsSum
  },
  {
    path: '/statistics/baseStatisticsDetail',
    name: 'baseStatisticsDetail',
    component: BaseMetricsDetail
  },
  {
    path: '/statistics/businessStatisticsSum',
    name: 'businessStatisticsSum',
    component: BusinessMetricsSum
  },
  {
    path: '/statistics/businessStatisticsDetail',
    name: 'businessStatisticsDetail',
    component: BusinessMetricsDetail
  },
  {
    path: '/statistics/configurationData',
    name: 'configurationData',
    component: ConfigurationData
  },
  {
    path: '/maps',
    name: 'maps',
    component: Maps
  },
]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

export default router
